import React, { useState } from "react";
import './Vault.css';
import { useVaultStore, useInventoryStore, usePlayerStore } from "../../store/store";
import { InformationPanel } from "../Inventory/Inventory";
import DraggableModal from '../Modal/DraggableModal';

function Vault({ sendMessage }) {

    const [deposit, setDepositGold] = useState(0);
    const [withdraw, setWithdrawGold] = useState(0);
    const [showUpgradeConfirm, setShowUpgradeConfirm] = useState(false);

    const id = useVaultStore((state) => state.id);
    const show = useVaultStore((state) => state.setShow);
    const balance = useVaultStore((state) => state.balance);
    const upgradeCost = useVaultStore((state) => state.upgradeCost);
    const vault = useVaultStore((state) => state.inventory);
    const inventory = useInventoryStore((state) => state.inventory);
    const gold = usePlayerStore((state) => state.gold);
    const itemInfo = useVaultStore((state) => state.itemInfo);

    const close = () => {
        show(false);
    }

    function getItemInfo(isVault, pos) {
        const list = isVault ? 0 : 1;
        sendMessage('853' + id + ";" + list + ";" + pos)
        console.log("ITEM INFO:", itemInfo);
    }

    const addItemToVault = (pos, amount) => {
        sendMessage('851' + id + ";" + pos + ";" + amount);
    }

    const getItemFromVault = (pos, amount) => {
        sendMessage('852' + id + ";" + pos + ";" + amount);
    }

    const addGold = () => {
        if (deposit > 0) {
            sendMessage('855' + id + ";" + deposit);
        }
    }

    const withdrawGold = () => {
        if (withdraw > 0) {
            sendMessage('856' + id + ";" + withdraw);
        }
    }

    const handleUpgradeClick = () => {
        setShowUpgradeConfirm(true);
    }

    const closeConfirmModal = () => {
        setShowUpgradeConfirm(false);
    }

    const confirmUpgrade = () => {
        sendMessage('600/vault upgrade YES');
        setShowUpgradeConfirm(false);
    }

    return (
        <>
            <DraggableModal modalId="vault" onClose={close}>
                <div className="modal-content" style={{ width: '780px' }}>
                    <div className="tmodal-header">
                        <span className="close" onClick={close}>&times;</span>
                        <h2>Vault</h2>
                    </div>
                    <div className="modal-body" style={{ width: '100%', padding: '2px 5px' }}>
                        <div className="vault-panel">
                            <div className="vault-split">
                                <div>
                                    <div className="bank-info">
                                        Gold: <span className="gold">{gold.toLocaleString()}</span>
                                        <input className="vault-amount" type="number" value={deposit} onChange={(e) => setDepositGold(e.target.value)} />
                                        <button onClick={addGold}>Deposit</button>
                                    </div>
                                    <div className="info-header"><p style={{ color: (inventory.invCount > inventory.invMax) ? 'red' : 'white' }}>Inventory ({inventory.invCount} / {inventory.invMax})</p></div>
                                    <VaultList itemList={inventory.itemList} getItemInfo={getItemInfo} isVault={false} addRemove={addItemToVault} />
                                </div>
                                <div>
                                    <div className="bank-info">
                                        Bank: <span className="gold">{balance.toLocaleString()}</span>
                                        <input className="vault-amount" type="number" value={withdraw} onChange={(e) => setWithdrawGold(e.target.value)} />
                                        <button onClick={withdrawGold}>Withdraw</button>
                                    </div>
                                    <div className="info-header"><p style={{ color: (vault.invCount > vault.invMax) ? 'red' : 'white' }}>Vault ({vault.invCount} / {vault.invMax})</p></div>
                                    <VaultList itemList={vault.itemList} getItemInfo={getItemInfo} isVault={true} addRemove={getItemFromVault} />
                                </div>
                            </div>
                            {itemInfo && <InformationPanel itemInfo={itemInfo} />}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="ts-close" onClick={close}>Close</button>
                        <button className="ts-button" onClick={handleUpgradeClick}>Upgrade</button>
                    </div>
                </div>
            </DraggableModal>
            {showUpgradeConfirm && (
                <DraggableModal modalId="vault-upgrade-confirm" onClose={closeConfirmModal}>
                    <div className="modal-content" style={{ width: '400px' }}>
                        <div className="tmodal-header">
                            <span className="close" onClick={closeConfirmModal}>&times;</span>
                            <h2>Confirm Vault Upgrade</h2>
                        </div>
                        <div className="modal-body">
                            <UpgradeConfirmContent
                                upgradeCost={upgradeCost}
                                balance={gold}
                            />
                        </div>
                        <div className="modal-footer">
                            <button className="ts-close" onClick={closeConfirmModal}>Cancel</button>
                            <button className="ts-button" onClick={confirmUpgrade} disabled={upgradeCost > gold}>Confirm</button>
                        </div>
                    </div>
                </DraggableModal>
            )}
        </>
    );

}

function VaultList({ itemList, getItemInfo, selected, isVault, addRemove }) {

    return (
        <div className="shop-list" style={{ height: '450px' }}>
            <ul>
                {itemList.map((e, i) => <Item key={i} item={e} index={i} isSelected={(i === selected)} getItemInfo={getItemInfo} isVault={isVault} addRemove={addRemove} />)}
            </ul>
        </div>
    )
}

function Item({ item, getItemInfo, index, isSelected, isVault, addRemove }) {
    const [value, setValue] = useState(item.qty);

    const updateValue = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setValue(Number(e.currentTarget.value));
    }

    const test = () => {
        addRemove(index, value);
    }

    return (
        <li style={{ borderColor: isSelected ? 'white' : '' }} >
            <div className="more-options">
                {item.qty > 1 && <input type="number" className="vault-amount" min={1} max={item.qty}  defaultValue={item.qty} onChange={(e) => updateValue(e)} />}
                <button className="vault-btn" onClick={test}>{isVault ? 'Get' : 'Add'}</button>
            </div>

            <div className="item" onClick={(e) => getItemInfo(isVault, index)} >
                <img src={require('../../Assets/gfx/' + item.picId + '.webp')} alt="" />
                <div className="item-info">
                    <span className="item-name" style={{ color: item.colour }}>
                        {index + 1}. {item.name} {item.qty > 1 && <> ({item.qty})</>} {item.maxSockets > 0 && <> [{item.usedSockets}/{item.maxSockets}]</>}
                        {item.cap > 0 && <> [{item.conItems}/{item.cap}]</>}
                    </span>

                    <span className="tag">
                            {item.tag}
                    </span>
                </div>
            </div>
        </li>
    );
}

function UpgradeConfirmContent({ upgradeCost, balance }) {
    const costColor = upgradeCost > balance ? '#ff6666' : '#66ff66';

    return (
        <div className="upgrade-confirm-content">
            <p className="confirm-message">
                Are you sure you want to upgrade your vault?
            </p>
            <div className="upgrade-details">
                <div className="detail-row">
                    <span className="detail-label">Upgrade Cost:</span>
                    <span className="detail-value cost" style={{ color: costColor }}>{upgradeCost.toLocaleString()}</span>
                </div>
                <div className="detail-row">
                    <span className="detail-label">Current Balance:</span>
                    <span className="detail-value balance">{balance.toLocaleString()}</span>
                </div>
                <div className="detail-row">
                    <span className="detail-label">Added Slots:</span>
                    <span className="detail-value slots">+5</span>
                </div>
            </div>
        </div>
    );
}


export default Vault;